// extracted by mini-css-extract-plugin
module.exports = {"more_dates":"PeriodsList_more_dates__Z15wJ","with_bg":"PeriodsList_with_bg__MXMUj"};